import { useEffect, useState } from "react";
import { IconButton, Typography, useTheme } from "@mui/material";
import { IMessage } from "~contexts/Socket/interfaces";
import { convertToHour } from "~helpers/chat";
import { MessageHistory } from "~components/atoms";
import { ReplyIcon } from "~components/Icons";
import { getStyles } from "./styles";
import RepliedMessage from "../RepliedMessage";
 
interface IProps {
  message: IMessage;
  messagesWithId: IMessage[];
  setReplyingTo: (value: IMessage | null) => void;
  id?: string;
}
 
const Message = ({ message, setReplyingTo, id, messagesWithId }: IProps) => {
  const theme: any = useTheme();
  const isResponseMessage = !!message.replyingTo;
  const { styles } = getStyles(theme, isResponseMessage);
  const [answeredTime, setAnsweredTime] = useState('');
 
  useEffect(() => {
    const answers = messagesWithId.filter((msg) => msg.replyingTo);
    const messageAnswered = answers.find((answer) => answer.replyingTo === message.id);
 
    if (messageAnswered) {
      setAnsweredTime(messageAnswered.time);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [messagesWithId]);


  return (
    <div id={id} style={styles.wrapper}>
      <div style={styles.content}>
        {isResponseMessage && <MessageHistory message={message} />}
        <div style={styles.texts}>
          <Typography component={"span"} style={styles.header}>
            {!isResponseMessage && (
              <span>
                <strong style={{ fontWeight: 900 }}>{message.name}</strong>
                <>({message.email})</>
              </span>
            )}
            {convertToHour(message.time)}
          </Typography>

          <Typography style={styles.text}>
            {message.text}
            {!isResponseMessage && (
              <IconButton
                disableRipple
                disableFocusRipple
                sx={styles.icon}
                onClick={() => setReplyingTo(message)}
              >
                <ReplyIcon />
              </IconButton>
            )}
          </Typography>
          {answeredTime && <RepliedMessage onTime={convertToHour(answeredTime)}/>}
        </div>
      </div>
    </div>
  );
};

export default Message;
